import { motion } from 'framer-motion';

const notes = [
  'All dates are estimates and subject to market conditions',
  'Development prioritizes security and sustainability',
  'Community feedback shapes development',
  'Focus on organic, sustainable growth',
  'Regular roadmap updates based on progress',
  'Flexibility to adapt to market conditions',
  'Continuous improvement focus'
];

export default function RoadmapNotes() {
  return (
    <div className="bg-white rounded-xl shadow-lg p-8">
      <h2 className="text-primary mb-6">Notes</h2>
      <ul className="space-y-3">
        {notes.map((note, index) => (
          <motion.li
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            className="flex items-center text-body text-gray-600"
          >
            <span className="w-2 h-2 bg-secondary rounded-full mr-3"></span>
            {note}
          </motion.li>
        ))}
      </ul>
    </div>
  );
}